import React from 'react';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
export default ({ text }) => {
  let status = '';
  switch (text) {
    case 'pending':
      status = 'invited';
      break;
    case undefined:
      status = 'confirmed';
      break;

    default:
      status = text;
  }
  let color = text === 'pending' ? '#ff9900' : undefined;
  if (!color) {
    color = text === 'joined' ? '#23af00' : undefined;
  }
  return <span style={{ color }}>{status}</span>;
};
